import { memo, useMemo } from 'react';
import { Line } from 'react-konva';
import Konva from 'konva';
import { FACET_DEFAULT_FILL_COLOR_ROOF_TOOL, FACET_HIGHLIGHT_COLOR, FACET_HIGHLIGHT_OFF_COLOR, KONVA_FACET_GROUP } from '../../../constants';
import { KonvaGroupNames } from '../utils';
import { useKonvaImageScale } from 'contexts/ToolDimensionsAndScaleContext';
import Label from './Label';
import { RootState } from 'store';
import { shallowEqual, useSelector } from 'react-redux';
interface Props extends Konva.LineConfig {
  roofSegment: RasterRoofSegment;
  selectedRoofID: string | null;
  roofEditingEnabled: boolean;
  isIrradianceOn: boolean;
	showFacetLabels: boolean;
}

const Facet = memo((props: Props) => {
	const { roofSegment, selectedRoofID, roofEditingEnabled, isIrradianceOn, showFacetLabels , ...lineconfig } = props;
	const scale = useKonvaImageScale();
	const { enabledDevMode, editModeEnabled } = useSelector((state: RootState) => {
		const tool = state.toolNewPostions.data;
		return { enabledDevMode: tool.enabledDevMode, editModeEnabled: tool.editModeEnabled };
	}, shallowEqual);

	const fillColor = useMemo(() => {
		const highlightFacet = roofSegment.id === selectedRoofID && !isIrradianceOn;
		switch(true){
		case highlightFacet :
			return FACET_HIGHLIGHT_COLOR;
		case roofEditingEnabled:
			return FACET_DEFAULT_FILL_COLOR_ROOF_TOOL;
		default:
			return FACET_HIGHLIGHT_OFF_COLOR;

		}
	}, [isIrradianceOn, roofSegment.id, selectedRoofID, roofEditingEnabled]);

	const strokeColor = useMemo(()=>{
		const usermappedAndInDevMode = enabledDevMode && roofSegment.userMapped;
		switch(true){
		case usermappedAndInDevMode:
			return '#FFFF00';
		case roofEditingEnabled:
			return '#003cff';
		case editModeEnabled:
			return 'rgba(29,53,87,.50)';
		default:
			return 'rgba(0, 0, 0, 0)';
		}
	},[editModeEnabled, enabledDevMode, roofEditingEnabled, roofSegment.userMapped]);

	return (
		<>
			<Line
				{...lineconfig}
				name={`${KonvaGroupNames.existingFacetsGroup}${KONVA_FACET_GROUP.GROUP_NAME_SEPARATOR}facet`}
				id={roofSegment.id}
				scale={scale}
				closed={true}
				strokeWidth={1}
				strokeScaleEnabled={false}
				points={roofSegment?.simplifiedHullCoords?.flat() || []}
				draggable={false}
				fill={fillColor}
				stroke={strokeColor}
			/>
		</>
	);
});

Facet.displayName = 'Facet';
export default Facet;